import axios from '../lib/axios';

export async function registerAtlasAccess(contractCode: string): Promise<void> {
  await axios.post('/api/atlas-access/register', { contractCode });
}
